import Loading from 'Shared/components/Loading'
import PageSettingsForm from './ActionForms/Components/PageSettingsForm'
import ShareSettingsForm from './ActionForms/Components/ShareSettingsForm'
import ThankYouEmailSettingsForm from './ActionForms/Components/ThankYouEmailSettingsForm'
import AdvancedSettingsForm from './ActionForms/Components/AdvancedSettingsForm'
import AccessSettingsForm from './ActionForms/Components/AccessSettingsForm'
import { useDefaultFlowLanguage } from 'FlowBuilder/hooks/useLanguageFlow'
import TranslationSettingsForm from './ActionForms/Components/TranslationSettingsForm'
import validate from 'FlowBuilder/lib/setupValidator'
import { useAct } from 'FlowBuilder/store'
import { clientLanguagesData } from 'Shared/TranslatableTextContent/clientLanguagesData'

export default function Setup({ }) {
  const act = useAct()
  const [tab, setTab] = useState('pageSettings')
  const {settings} = useSel(s => s.builder?.flow || {})
  const actions = useSel(s => _.values(s.actions.entities) || [])
  const surveyAction = actions.find(a => a.kind === 'survey')
  const clientLanguages = useMemo(() => clientLanguagesData());
  const defaultLanguage = useDefaultFlowLanguage()

  const tabClasses = (thisTab) => {
    let classes = ['tab']
    if (thisTab === tab) {
      classes.push('selected')
    }
    return classes.join(' ')
  }

  if(!settings) {
    return <Loading />
  }

  const memoizedActions = useMemo(() => actions, [JSON.stringify(actions)]);

  useEffect(() => {
    const errors = [];
    validate({settings, actions: memoizedActions, defaultLanguage ,setErrors: (validationErrors) => {
      errors.push(...validationErrors);
    }});
    act.builder.setSetupValidationErrors(_.uniq(errors));

    return () => act.builder.setSetupValidationErrors([]);
  }, [settings, memoizedActions, defaultLanguage]);

  const usesTranslations = clientLanguages && Object.keys(clientLanguages).length > 1

  return <>
    <div className="box">
      <h2 className="no-margin-top">Setup</h2>

      <div className='row margin-bottom'>
        <div className='tabs'>
          {surveyAction && <div className={tabClasses('accessSettings')} onClick={() => setTab('accessSettings')}>Access Settings</div>}
          <div className={tabClasses('pageSettings')} onClick={() => setTab('pageSettings')}>Page Settings</div>
          <div className={tabClasses('shareSettings')} onClick={() => setTab('shareSettings')}>Share Settings</div>
          {surveyAction && <div className={tabClasses('emailSettings')} onClick={() => setTab('emailSettings')}>Thank You Email Settings</div>}
          <div className={tabClasses('translationSettings')} onClick={() => setTab('translationSettings')}>{usesTranslations ? 'Translations' : 'Static text'}</div>
          <div className={tabClasses('advancedSettings')} onClick={() => setTab('advancedSettings')}>Advanced Settings</div>
        </div>
      </div>

      { tab === 'accessSettings' && surveyAction && <AccessSettingsForm actionId={surveyAction.id} /> }
      {tab === 'pageSettings' && <PageSettingsForm />}
      {tab === 'shareSettings' && <ShareSettingsForm />}
      {tab === 'emailSettings' && surveyAction && <ThankYouEmailSettingsForm actionId={surveyAction.id} />}
      {tab === 'translationSettings' && <TranslationSettingsForm />}
      {tab === 'advancedSettings' && <AdvancedSettingsForm />}
    </div>
  </>
}
